import { useContext, useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';

import NavigationContext from '../context/NavigationContext';
import FirebaseContext from '../../context/FirebaseContext';
import useSessionStore from '../../hooks/useSessionStore';
import useComponentMounted from '../../hooks/useComponentMounted';

const ActiveRoute = ({ pageId, children }) => {
  const {
    setActivePage,
  } = useContext(NavigationContext);
  const {
    firebase: { remote },
  } = useContext(FirebaseContext);
  const {
    authUser: {
      uid: userId,
      displayName: name,
      email,
    },
  } = useSessionStore();

  const [emailHash, setEmailHash] = useState(null);
  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    setActivePage(pageId);
  }, [
    pageId,
    setActivePage,
  ]);

  useEffect(() => {
    const fetchHash = async () => {
      if (!userId || !email) return;

      try {
        const response = await remote('pylon-getIdentityVerificationToken', { userId, email });

        if (!response.ok) {
          throw new Error(`Firebase function returned status ${response.status}`);
        }

        const data = await response.json();

        if (isComponentMountedRef.current && data.success && data.verificationHash) {
          setEmailHash(data.verificationHash);
        }
      } catch (error) {
        Sentry.captureException(error, {
          extra: {
            userId,
            email,
            message: 'Error fetching hash from Firebase function',
          },
        });
      }
    };

    fetchHash();
  }, [
    userId,
    email,
    remote,
    isComponentMountedRef,
  ]);

  useEffect(() => {
    if (emailHash && userId && email && name) {
      window.pylon = {
        chat_settings: {
          app_id: window.system2.config.pylonAppId,
          email,
          name,
          email_hash: emailHash,
          account_id: window.system2.config.pylonSupportAccountId,
        },
      };
    }
  }, [
    emailHash,
    userId,
    email,
    name,
  ]);

  return children;
};

export default ActiveRoute;
